import { render, staticRenderFns } from "./TicketColumnCard.vue?vue&type=template&id=8d485f6e&scoped=true"
import script from "./TicketColumnCard.vue?vue&type=script&lang=js"
export * from "./TicketColumnCard.vue?vue&type=script&lang=js"
import style0 from "./TicketColumnCard.vue?vue&type=style&index=0&id=8d485f6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d485f6e",
  null
  
)

export default component.exports